import React from "react";
import styled, { css } from "styled-components";
import useRobinsonHome from "./useHome";
import GTMSetOriginalUrl from "../GoogleTagManager/GTMSetOriginalUr";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";
import InfoSection from "../InfoSection/InfoSection";
import Helmet from "react-helmet";

const StyledRobinsonHome = styled.div`
  margin: 0 auto 57px;
  max-width: 1200px;
  line-height: 1.375;
  overflow: hidden;
`;

const StyledHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 30px 30px 30px 7px;
`;

const StyledBody = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 30px 0;
  align-items: center;
  min-height: 580px;
  background: linear-gradient(
    109.25deg,
    #e0fdfd -3.84%,
    #ddd9eb 48.04%,
    #f3e0f8 77.45%,
    #e7eaf9 98.85%
  );

  @media (max-width: ${({ theme }) => theme?.mediaScreen?.tabletVertical}) {
    display: block;
  }

  & > * {
    transition-duration: 0.75s;
    transition-timing-function: cubic-bezier(0.16, -0.03, 0.58, 1);
    transition-property: opacity, transform;

    ${({ $animate }) =>
      $animate &&
      css`
        transition-duration: 0s;
        transform: translateY(5px);
        opacity: 0;
      `}
  }
`;

const StyledImageWrapper = styled.div`
  flex: 1;
  display: flex;
  place-content: center;
`;

const StyledImageSection = styled.img`
  min-height: 568px;
  @media (max-width: ${({ theme }) => theme?.mediaScreen?.tabletVertical}) {
    display: none !important;
  }
`;

const RobinsonHome = () => {
  const {
    handleRedirect,
    handleSwitchLanguage,
    translate,
    isMobile,
    langCode = "th",
    shouldAnimate,
    isRedirected,
  } = useRobinsonHome();
  return (
    <StyledRobinsonHome>
      <Helmet>
        <title>
          {process.env[`REACT_APP_TITLE_${langCode?.toUpperCase()}`]}
        </title>
        <meta
          name="description"
          content={
            process.env[`REACT_APP_DESCRIPTION_${langCode?.toUpperCase()}`]
          }
        />
      </Helmet>
      <StyledHeader>
        <div>
          <img src="/images/logo.svg" alt="logo" />
        </div>
        <LanguageSwitch
          handleSwitchLanguage={handleSwitchLanguage}
          langCode={langCode}
        />
      </StyledHeader>
      <GTMSetOriginalUrl />
      <StyledBody $animate={shouldAnimate}>
        <InfoSection
          shouldAnimate={shouldAnimate}
          translate={translate}
          handleRedirect={handleRedirect}
          isRedirected={isRedirected}
          isMobile={isMobile}
        />
        <StyledImageWrapper $animate={shouldAnimate}>
          <StyledImageSection src={`/images/shop-now-${langCode}.svg`} />
        </StyledImageWrapper>
      </StyledBody>
    </StyledRobinsonHome>
  );
};

export default RobinsonHome;
